export function encodeQueryParams(queryParams?: {}): string {
  if (!queryParams) {
    return "";
  }
  const params: string[] = [];

  for (const key in queryParams) {
    if (queryParams.hasOwnProperty(key)) {
      params.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      );
    }
  }

  return params.length > 0 ? `?${params.join("&")}` : "";
}
